import { sanitizeFileUrl } from "./filePreview.js";

/**
 * Baut die URL für GET /api/files/preview-meta
 */
export function buildPreviewMetaUrl({
  module = "",
  fileId = null,
  projektTyp = "",
  projektId = null,
  entityId = null,
} = {}) {
  const mod = String(module || "").trim();
  const fid = Number(fileId);
  if (!mod || !Number.isFinite(fid) || fid <= 0) return "";

  const params = new URLSearchParams();
  params.set("module", mod);
  params.set("fileId", String(fid));
  if (projektTyp) params.set("projektTyp", String(projektTyp));
  if (projektId != null && Number(projektId) > 0) {
    params.set("projektId", String(projektId));
  }
  if (entityId != null && Number(entityId) > 0) {
    params.set("entityId", String(entityId));
  }
  return `/api/files/preview-meta?${params.toString()}`;
}

/**
 * Baut die URL für GET /api/files/preview-meta/attachment (Bild-Anhänge in E-Mails).
 */
export function buildPreviewAttachmentUrl({
  module = "",
  fileId = null,
  index = null,
  projektTyp = "",
  projektId = null,
  entityId = null,
} = {}) {
  const mod = String(module || "").trim();
  const fid = Number(fileId);
  const idx = Number(index);
  if (!mod || !Number.isFinite(fid) || fid <= 0) return "";
  if (!Number.isInteger(idx) || idx < 0) return "";

  const params = new URLSearchParams();
  params.set("module", mod);
  params.set("fileId", String(fid));
  params.set("index", String(idx));
  if (projektTyp) params.set("projektTyp", String(projektTyp));
  if (projektId != null && Number(projektId) > 0) {
    params.set("projektId", String(projektId));
  }
  if (entityId != null && Number(entityId) > 0) {
    params.set("entityId", String(entityId));
  }
  return `/api/files/preview-meta/attachment?${params.toString()}`;
}

export async function fetchPreviewMeta(url = "", { signal } = {}) {
  const safe = sanitizeFileUrl(url);
  if (!safe || !safe.startsWith("/api/files/preview-meta")) {
    throw new Error("INVALID_PREVIEW_META_URL");
  }
  // Attachment-Endpoint liefert Binärdaten, nicht JSON-Meta
  if (safe.startsWith("/api/files/preview-meta/attachment")) {
    throw new Error("INVALID_PREVIEW_META_URL");
  }
  const res = await fetch(safe, {
    method: "GET",
    credentials: "include",
    signal,
  });
  if (!res.ok) {
    throw new Error(`PREVIEW_META_${res.status}`);
  }
  const data = await res.json();
  if (!data || data.ok === false) {
    throw new Error("PREVIEW_META_FAILED");
  }
  return data;
}
